import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import {
    createTopicsApi,
    generatePrompts,
    generateTopicsApi,
    getGeneratedAllTopicsApi,
    getGeneratedPromptsApi,
    getGeneratedTopicsApi,
} from './query';
import ReactSelect from '../../../../../components/ReactSelect';
import Loading from '../../../../../components/Loading';
import { COUNTRIES } from '../../../create/countries';
import { LANGUAGES } from '../../../create/languages';
import ProjectEditModal from '../../../projects/modal/EditProject/modal';
import AddKeywordModal from '../addKeywordModal';
import ErrorMessage from '../../../ErrorMessage';
import PromptsView from '../PromptsView';
import DomainImage from '../../../../../components/DomainImage';
import {
    getStoredCountryLanguage,
    resolveCountryLanguage,
    saveCountryLanguage,
} from '../../../../../helpers/aiTrackingCountryLanguage';

class BrandEntities extends Component {
    constructor(props) {
        super(props);

        this.handleSelectCountry = this.handleSelectCountry.bind(this);
        this.handleSelectProject = this.handleSelectProject.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.onGenerateTopics = this.onGenerateTopics.bind(this);
        this.onOpenEditModal = this.onOpenEditModal.bind(this);
        this.onCloseEditModal = this.onCloseEditModal.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.openAddKeywordModal = this.openAddKeywordModal.bind(this);
        this.closeAddKeywordModal = this.closeAddKeywordModal.bind(this);
        this.showOpened = this.showOpened.bind(this);
        this.onClickOnStep = this.onClickOnStep.bind(this);
        this.onSelectPrompts = this.onSelectPrompts.bind(this);
        this.showParentOpened = this.showParentOpened.bind(this);
        this.onClickOnParentStep = this.onClickOnParentStep.bind(this);
        this.onSelectAllPrompts = this.onSelectAllPrompts.bind(this);
        this.onSelectTopic = this.onSelectTopic.bind(this);
        this.onGeneratePrompts = this.onGeneratePrompts.bind(this);
        this.onChangeCustomTopics = this.onChangeCustomTopics.bind(this);
        this.onShowExistingTopics = this.onShowExistingTopics.bind(this);
        this.handleSelectTopicsSource = this.handleSelectTopicsSource.bind(this);
        this.onCreateTopics = this.onCreateTopics.bind(this);
        this.onGeneratePromptsFromAi = this.onGeneratePromptsFromAi.bind(this);
        this.getAlreadyGeneratedTopics = this.getAlreadyGeneratedTopics.bind(this);

        const userCountryLanguage = getStoredCountryLanguage();

        this.url = new URL(window.location);
        this.projectId = this.url.searchParams.get('projectId');

        this.state = {
            selectedCollapse: ['l-0', 'r-0'],
            selectedParentCollapse: 1,
            brand: '',
            entities: [],
            errors: {},
            loading: false,
            country: userCountryLanguage?.country ?? '',
            language: userCountryLanguage?.language ?? '',
            selectedProject: '',
            isEditModalOpen: false,
            isInProgress: false,
            isInProgressTopics: false,
            prompts: [],
            selectedItems: [],
            isAddKeywordModalOpen: false,
            topics: [],
            showStep2: false,
            showStep3: false,
            generatedTopics: [],
            selectedTopics: [],
            topicsErrorMessage: '',
            alreadyGeneratedTopics: [],
            showExistingTopics: false,
            topicsSource: 'manual',
            createdTopics: [],
            manuallyAddedPrompts: [],
            aiGeneratedPrompts: [],
        };
    }

    handleSelectTopicsSource(event) {
        const { value } = event.target;
        return this.setState({
            topicsSource: value,
            selectedCollapse: ['l-0', 'r-0'],
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(this.props.projects) !== JSON.stringify(prevProps.projects)) {
            if (!this.projectId) return;
            const selectedProject =
                this.props.projects.find((x) => Number(x.id) === Number(this.projectId)) ?? null;
            if (selectedProject) {
                this.setState({
                    selectedProject: selectedProject.value,
                    ...resolveCountryLanguage(selectedProject),
                });
            }
        }
    }

    sortByOrder(data) {
        if (!Array.isArray(data)) return data;
        return [...data]
            .sort((a, b) => (a?.ord ?? 0) - (b?.ord ?? 0))
            .map((item) =>
                Array.isArray(item?.generated_prompts)
                    ? { ...item, generated_prompts: this.sortByOrder(item.generated_prompts) }
                    : item,
            );
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => {
            return item.prompt?.toLowerCase().includes(search.toLowerCase());
        });
    }

    onOpenEditModal() {
        this.setState({ isEditModalOpen: true });
    }

    onCloseEditModal() {
        this.setState({ isEditModalOpen: false });
    }

    openAddKeywordModal() {
        this.setState({ isAddKeywordModalOpen: true });
    }

    closeAddKeywordModal() {
        this.setState({ isAddKeywordModalOpen: false });
    }

    showOpened(name, value) {
        return this.state.selectedCollapse.includes(name) ? value ?? 'active' : '';
    }

    onClickOnStep(id) {
        this.setState({
            selectedCollapse: this.state.selectedCollapse.includes(id)
                ? this.state.selectedCollapse.filter((item) => item !== id)
                : [...this.state.selectedCollapse, id],
        });
    }

    showParentOpened(name, value) {
        return this.state.selectedParentCollapse === name ? value ?? 'active' : '';
    }

    onClickOnParentStep(id) {
        this.setState({
            selectedParentCollapse: this.state.selectedParentCollapse === id ? null : id,
        });
    }

    async getGeneratedPrompts(id, keyName) {
        try {
            const response = await getGeneratedPromptsApi(id);
            const data = await response.json();

            if (data.status === 'completed') {
                const topics = this.sortByOrder(data?.topics || []);
                this.setState({ [keyName]: topics, isInProgress: false });
            } else if (data.status === 'pending') {
                setTimeout(() => {
                    this.getGeneratedPrompts(id, keyName);
                }, 5000);
            } else if (data.status === 'failed') {
                this.setState({
                    isInProgress: false,
                    errorMessage:
                        data.error_message ??
                        this.props.t('ai_tracking.prompt_generator.failed_to_generate_prompts'),
                });
            }
        } catch (err) {
            console.log('err', err);
        }
    }

    async getGeneratedTopics(id) {
        try {
            const response = await getGeneratedTopicsApi(id);
            const data = await response.json();

            if (data.status === 'completed') {
                const topics = this.sortByOrder(data?.topics);
                this.setState({ generatedTopics: topics, isInProgressTopics: false });
            } else if (data.status === 'pending') {
                setTimeout(() => {
                    this.getGeneratedTopics(id);
                }, 5000);
            } else if (data.status === 'failed') {
                this.setState({
                    isInProgressTopics: false,
                    errorMessage:
                        data.error_message ??
                        this.props.t('ai_tracking.prompt_generator.failed_to_generate_prompts'),
                });
            }
        } catch (err) {
            console.log('err', err);
        }
    }

    async getAlreadyGeneratedTopics(id) {
        try {
            this.setState({ alreadyGeneratedTopicsLoading: true, alreadyGeneratedTopics: [] });
            const res = await getGeneratedAllTopicsApi(id);
            const data = await res.json();
            if (data?.length) {
                this.setState({
                    alreadyGeneratedTopics: data,
                    alreadyGeneratedTopicsLoading: false,
                });
            }
        } catch (err) {
            console.log('err', err);
        } finally {
            this.setState({ alreadyGeneratedTopicsLoading: false });
        }
    }

    openEditModal() {
        this.setState({ isEditModalOpen: true });
    }
    closeEditModal() {
        this.setState({ isEditModalOpen: false });
    }

    handleSelectProject = (selectedOption) => {
        const project = this.props.projects.find((x) => x.value === selectedOption) ?? null;

        this.setState({
            selectedProject: selectedOption,
            errors: { ...this.state.errors, project: null, country: null, language: null },
            ...resolveCountryLanguage(project),
        });
    };

    handleSelectCountry(data) {
        this.setState({
            country: data.value,
            language: data.language,
            errors: {
                ...this.state.errors,
                country: null,
                language: null,
            },
        });
    }

    handleSelect(value, name) {
        this.setState({ [name]: value, errors: { ...this.state.errors, [name]: null } });
    }

    async onGenerateTopics(e) {
        try {
            e.preventDefault();
            let isError = false;
            let errors = {};

            const selectedProject = this.props.projects.find(
                (x) => x.value === this.state.selectedProject,
            );

            if (!selectedProject?.own_domain || !selectedProject?.own_product_name) {
                errors.project = this.props.t(
                    'ai_tracking.prompt_generator.brand_and_domain_required',
                );
                isError = true;
            }
            if (!this.state.country) {
                errors.country = this.props.t('ai_tracking.prompt_generator.country_required');
                isError = true;
            }
            if (!this.state.language) {
                errors.language = this.props.t('ai_tracking.prompt_generator.language_required');
                isError = true;
            }

            if (isError) {
                return this.setState((prevState) => ({
                    errors: { ...prevState.errors, ...errors },
                }));
            }

            this.getAlreadyGeneratedTopics(this.state.selectedProject);
            this.setState({
                loading: true,
                showStep2: true,
                isInProgressTopics: true,
                errorMessage: null,
            });
            this.onClickOnParentStep(3);
            this.scrollToBottom();

            const formData = {
                brand_name: selectedProject?.own_product_name,
                brand_domain: selectedProject?.own_domain,
                country: this.state.country,
                language: this.state.language,
                project: this.state.selectedProject,
            };

            saveCountryLanguage({
                country: this.state.country,
                language: this.state.language,
            });

            const response = await generateTopicsApi(formData);
            const data = await response.json();

            if (data.status === 'completed') {
                const topics = this.sortByOrder(data?.topics);
                this.setState({ generatedTopics: topics, isInProgressTopics: false });
            } else if (data.status === 'pending') {
                this.getGeneratedTopics(data.id);
                this.setState({ isInProgressTopics: false });
            } else if (data.status === 'failed' || response.status > 201) {
                this.setState({
                    isInProgressTopics: false,
                    errorMessage:
                        data.error_message ??
                        data.detail ??
                        this.props.t('ai_tracking.prompt_generator.failed_to_generate_prompts'),
                });
            }

            this.scrollToBottom();
        } catch (err) {
            console.log('err', err);
        } finally {
            this.setState({ loading: false });
        }
    }

    onGeneratePromptsFromAi(e) {
        e.preventDefault();
        this.onGeneratePrompts();
    }

    async onGeneratePrompts(topicIds) {
        try {
            let isError = false;
            let errors = {};
            const isFromManual = !!topicIds;
            const keyName = isFromManual ? 'manuallyAddedPrompts' : 'aiGeneratedPrompts';

            const selectedProject = this.props.projects.find(
                (x) => x.value === this.state.selectedProject,
            );

            if (!selectedProject?.own_domain || !selectedProject?.own_product_name) {
                errors.project = this.props.t(
                    'ai_tracking.prompt_generator.brand_and_domain_required',
                );
                isError = true;
            }
            if (!this.state.country) {
                errors.country = this.props.t('ai_tracking.prompt_generator.country_required');
                isError = true;
            }
            if (!this.state.language) {
                errors.language = this.props.t('ai_tracking.prompt_generator.language_required');
                isError = true;
            }

            if (isError) {
                return this.setState((prevState) => ({
                    errors: { ...prevState.errors, ...errors },
                }));
            }

            this.setState({
                loading: true,
                showStep3: true,
                isInProgress: true,
                errorMessage: null,
                topics: [],
            });

            if (isFromManual) {
                this.setState({
                    showStep3ForManual: true,
                });
            } else {
                this.setState({
                    showStep3ForAi: true,
                });
            }

            this.scrollToBottom();
            this.onClickOnParentStep(3);

            const formData = {
                brand_name: selectedProject?.own_product_name,
                brand_domain: selectedProject?.own_domain,
                country: this.state.country,
                language: this.state.language,
                project: this.state.selectedProject,
                topic_ids: topicIds ?? this.state.selectedTopics,
            };

            saveCountryLanguage({
                country: this.state.country,
                language: this.state.language,
            });

            const response = await generatePrompts(formData);
            const data = await response.json();
            if (data?.status === 'completed') {
                const topics = this.sortByOrder(data?.topics || []);
                this.setState({ [keyName]: topics, isInProgress: false });
            } else if (data.status === 'pending') {
                this.getGeneratedPrompts(data.id, keyName);
                this.setState({ isInProgress: false });
            } else if (data.status === 'failed' || response.status > 201) {
                this.setState({
                    isInProgress: false,
                    errorMessage:
                        data.error_message ??
                        data.detail ??
                        this.props.t('ai_tracking.prompt_generator.failed_to_generate_prompts'),
                });
            }

            this.scrollToBottom();
        } catch (err) {
            console.log('err', err);
        } finally {
            this.setState({ loading: false });
        }
    }

    onSelect(action, state) {
        if (action.type === 'REMOVE_ALL') return this.setState({ selectedItems: [] });
        this.setState({
            selectedItems: state.ids,
        });
    }

    onSelectPrompts(prompt) {
        this.setState({
            selectedItems: this.state.selectedItems.includes(prompt)
                ? this.state.selectedItems.filter((item) => item !== prompt)
                : [...this.state.selectedItems, prompt],
        });
    }

    onSelectAllPrompts(prompts) {
        const allSelected = prompts.every((prompt) => this.state.selectedItems.includes(prompt));
        this.setState({
            selectedItems: allSelected
                ? this.state.selectedItems.filter((item) => !prompts.includes(item))
                : [...new Set([...this.state.selectedItems, ...prompts])],
        });
    }

    onSelectTopic(topic) {
        const newTopics = this.state.selectedTopics.includes(topic)
            ? this.state.selectedTopics.filter((item) => item !== topic)
            : [...this.state.selectedTopics, topic];

        if (newTopics.length > 20) {
            this.setState({
                topicsErrorMessage: 'You can select up to 20 topics only.',
            });
            return;
        }

        this.setState({
            selectedTopics: newTopics,
            topicsErrorMessage: '',
        });
    }

    onChangeCustomTopics(e) {
        this.setState({
            customTopics: e.target.value,
        });
    }

    onShowExistingTopics() {
        this.setState({
            showExistingTopics: true,
        });
    }

    async onCreateTopics() {
        try {
            this.setState({ createTopicLoading: true });
            const selectedTopics = this.state.customTopics
                .split('\n')
                .map((topic) => topic.trim())
                .filter((topic) => topic);
            const body = {
                items: selectedTopics?.map((topic) => ({ name: topic, description: '' })) || [],
                project: this.state.selectedProject,
            };
            const res = await createTopicsApi(body);
            const data = await res.json();
            this.setState((prevState) => ({
                createdTopics: [...prevState.createdTopics, data],
            }));
            this.onGeneratePrompts(data?.map((item) => item.id));
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({ createTopicLoading: false });
        }
    }

    scrollToBottom() {
        setTimeout(() => {
            window.scrollTo(0, document.body.scrollHeight);
        }, 100);
    }

    render() {
        const { t } = this.props;
        const selectedProject =
            this.props.projects.find((x) => x.value === this.state.selectedProject) ?? null;

        const disableThirdStep =
            !selectedProject?.own_product_name ||
            this.state.isInProgressTopics ||
            !this.state.language ||
            !this.state.country ||
            this.props.promptCredits <= 0;

        const projectOptions = this.props.projects.map((project) => ({
            label: (
                <div className="d-flex align-items-center gap-8">
                    {project.label}{' '}
                    {project.is_default && (
                        <span className="ai-tracking-default-selected white">
                            {t('ai_tracking.global.default')}
                        </span>
                    )}
                </div>
            ),
            value: project.value,
        }));

        const topicKeyName =
            this.state.topicsSource === 'manual' ? 'manuallyAddedPrompts' : 'aiGeneratedPrompts';
        const alreadyGeneratedTopics =
            this.state.alreadyGeneratedTopics?.map((topic) => topic.name) || [];

        const firstTreeGeneratedTopics = alreadyGeneratedTopics?.slice(0, 3) || [];
        return (
            <>
                <div className="card">
                    <div className="card-body">
                        <div className="prompt-generator-title">
                            <div className="prompt-generator-number">1</div>
                            <div className="prompt-generator-label">
                                {t('ai_tracking.add_keyword.project')}
                                {selectedProject && (
                                    <div className="prompt-generator-selected-project">
                                        <DomainImage
                                            domain_name={selectedProject?.own_domain}
                                            size="20"
                                        />
                                        <div>{selectedProject?.own_product_name}</div>
                                        <span>{selectedProject?.own_domain}</span>
                                        <button
                                            onClick={this.onOpenEditModal}
                                            disabled={!selectedProject}
                                        >
                                            <i className="icon-pencil" />
                                        </button>
                                    </div>
                                )}
                                {selectedProject && !selectedProject?.own_domain && (
                                    <div className="error-message">
                                        {t(
                                            'ai_tracking.prompt_generator.project_inclomplete_message',
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="prompt-generator-selects-box">
                            <div>
                                <ReactSelect
                                    options={projectOptions}
                                    value={selectedProject}
                                    onChange={this.handleSelectProject}
                                    blurInputOnSelect={true}
                                    label={
                                        <div className="select-label">
                                            {t('ai_tracking.global.project')} <span>*</span>
                                        </div>
                                    }
                                    classname="mr-0"
                                    disabled={this.props.projectLoader}
                                    isSearchable
                                    components={{
                                        IndicatorSeparator: () => null,
                                    }}
                                />
                                {this.state.errors['project'] && (
                                    <div className="error-message">
                                        {this.state.errors['project']}
                                    </div>
                                )}
                            </div>
                            <div>
                                <ReactSelect
                                    options={COUNTRIES}
                                    value={COUNTRIES.find((x) => x.value === this.state.country)}
                                    label={
                                        <div className="select-label">
                                            {t('ai_tracking.add_keyword.country')} <span>*</span>
                                        </div>
                                    }
                                    placeholder={t('ai_tracking.add_keyword.country')}
                                    customeOnChange={this.handleSelectCountry}
                                    blurInputOnSelect={true}
                                    classname="mr-0"
                                    disabled={this.state.loading}
                                    isSearchable
                                    components={{
                                        IndicatorSeparator: () => null,
                                    }}
                                />
                                {this.state.errors['country'] && (
                                    <div className="error-message">
                                        {this.state.errors['country']}
                                    </div>
                                )}
                            </div>

                            <div>
                                <ReactSelect
                                    options={LANGUAGES}
                                    value={LANGUAGES.find((x) => x.value === this.state.language)}
                                    label={
                                        <div className="select-label">
                                            {t('ai_tracking.add_keyword.language')} <span>*</span>
                                        </div>
                                    }
                                    placeholder={t('ai_tracking.add_keyword.language')}
                                    onChange={(e) => this.handleSelect(e, 'language')}
                                    blurInputOnSelect={true}
                                    classname="mr-0"
                                    disabled={this.state.loading}
                                    isSearchable
                                    components={{
                                        IndicatorSeparator: () => null,
                                    }}
                                />
                                {this.state.errors['language'] && (
                                    <div className="error-message">
                                        {this.state.errors['language']}
                                    </div>
                                )}
                            </div>
                        </div>
                        {this.props.projectLoader && <Loading padding="10px 0" />}

                        <div className="ai-tracking-brand-focused-topics">
                            <label>Brand Focused Topics</label>
                            <div className="ai-tracking-brand-focused-topics-body">
                                <label>
                                    <div className="ai-tracking-radio-input">
                                        <input
                                            type="radio"
                                            name="topicsSource"
                                            value="manual"
                                            checked={this.state.topicsSource === 'manual'}
                                            onChange={this.handleSelectTopicsSource}
                                        />{' '}
                                        <span className="custom-radio"></span>
                                    </div>
                                    {t('ai_tracking.prompt_generator.enter_topics_manually')}
                                </label>
                                <label>
                                    <div className="ai-tracking-radio-input">
                                        <input
                                            type="radio"
                                            name="topicsSource"
                                            value="ai"
                                            checked={this.state.topicsSource === 'ai'}
                                            onChange={this.handleSelectTopicsSource}
                                        />{' '}
                                        <span className="custom-radio"></span>
                                    </div>
                                    {t('ai_tracking.prompt_generator.enter_topics_by_ai')}
                                </label>
                            </div>
                        </div>

                        <div className="mt-20">
                            {this.state.topicsSource === 'manual' && (
                                <>
                                    <label className="ai-tracking-create-label">
                                        {t('ai_tracking.prompt_generator.manualy_topics_label')}{' '}
                                        <span className="text-danger">*</span> <br />
                                        <small>
                                            {t(
                                                'ai_tracking.prompt_generator.manualy_topics_subheader',
                                            )}
                                        </small>
                                    </label>
                                    <textarea
                                        type="text"
                                        name="keywords"
                                        className="select-topic-textarea"
                                        value={this.state.customTopics}
                                        onChange={this.onChangeCustomTopics}
                                        disabled={this.state.createTopicLoading}
                                        style={{
                                            minHeight: '100px',
                                        }}
                                    ></textarea>

                                    <div className="mt-10">
                                        <div className="mt-10 w-100 d-flex justify-content-end">
                                            <div>
                                                <button
                                                    onClick={this.onCreateTopics}
                                                    className="button button-filled button-primary"
                                                    disabled={
                                                        this.state.createTopicLoading ||
                                                        this.props.promptCredits === 0 ||
                                                        !selectedProject?.own_product_name
                                                    }
                                                >
                                                    {t(
                                                        'ai_tracking.prompt_generator.generate_prompts',
                                                    )}
                                                </button>
                                                <div className="prompt-generation-count">
                                                    {this.state.createTopicLoading ? (
                                                        <Loading />
                                                    ) : (
                                                        <>
                                                            {this.props.promptCredits}{' '}
                                                            {t(
                                                                'ai_tracking.global.prompts_generation_left',
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        {!this.props.getCreditsLoader &&
                                            this.props.promptCredits === 0 && (
                                                <ErrorMessage
                                                    message={t(
                                                        'ai_tracking.global.prompts_generation_left_message',
                                                    )}
                                                />
                                            )}
                                    </div>
                                </>
                            )}
                            {this.state.topicsSource === 'ai' && (
                                <div>
                                    <div className="d-flex gap-16">
                                        <div>
                                            <button
                                                onClick={this.onGenerateTopics}
                                                className="button button-filled button-primary"
                                                disabled={disableThirdStep}
                                            >
                                                {t(
                                                    'ai_tracking.prompt_generator.generate_topics_by_ai',
                                                )}
                                            </button>
                                            <div className="prompt-generation-count">
                                                {this.props.getCreditsLoader ? (
                                                    <Loading />
                                                ) : (
                                                    <>
                                                        {this.props.promptCredits}{' '}
                                                        {t(
                                                            'ai_tracking.global.prompts_generation_left',
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {!this.props.getCreditsLoader &&
                                        this.props.promptCredits === 0 && (
                                            <ErrorMessage
                                                message={t(
                                                    'ai_tracking.global.prompts_generation_left_message',
                                                )}
                                            />
                                        )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {this.state.topicsSource === 'ai' && this.state.showStep2 && (
                    <div className="card">
                        <div className="card-body">
                            <div className="prompt-generator-title">
                                <div className="prompt-generator-number">2</div>
                                <div className="prompt-generator-label">
                                    {' '}
                                    {t('ai_tracking.prompt_generator.select_topics')}
                                </div>
                            </div>
                            {!this.state.generatedTopics.length &&
                                !this.state.isInProgressTopics &&
                                !this.state.errorMessage && (
                                    <div className="prompt-generator-subtitle">
                                        {t('global.no_data')}
                                    </div>
                                )}
                            <div>
                                {this.state.isInProgressTopics && (
                                    <div className="mt-20 d-flex gap-8">
                                        <strong>
                                            {t(
                                                'ai_tracking.prompt_generator.generate_topic_message',
                                            )}
                                        </strong>{' '}
                                        <Loading />{' '}
                                    </div>
                                )}
                                {this.state.errorMessage && (
                                    <div className="mt-20 error-message">
                                        <strong>{this.state.errorMessage}</strong>{' '}
                                    </div>
                                )}
                            </div>
                            {this.state.generatedTopics.length > 0 && (
                                <>
                                    <div className="prompt-generator-body-box grid-1">
                                        <div className="prompt-generator-body-box-content">
                                            <div className="prompt-generator-step-box-body">
                                                {this.state.generatedTopics.map((topic, idx) => (
                                                    <div
                                                        key={idx}
                                                        className="gap-10 d-flex align-items-center"
                                                    >
                                                        <input
                                                            id={topic?.id}
                                                            type="checkbox"
                                                            onChange={() =>
                                                                this.onSelectTopic(topic?.id)
                                                            }
                                                            checked={this.state.selectedTopics.includes(
                                                                topic?.id,
                                                            )}
                                                        />
                                                        <label htmlFor={topic?.id}>
                                                            {topic?.name}{' '}
                                                            <span className="topic-description">
                                                                ({topic?.description})
                                                            </span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    {this.state.topicsErrorMessage && (
                                        <ErrorMessage
                                            warning
                                            message={this.state.topicsErrorMessage}
                                        />
                                    )}

                                    <div className="mt-10 d-flex justify-content-end">
                                        <div>
                                            <button
                                                onClick={this.onGeneratePromptsFromAi}
                                                className="button button-filled button-primary"
                                                disabled={
                                                    this.state.selectedTopics.length === 0 ||
                                                    this.props.promptCredits === 0 ||
                                                    this.state.isInProgress
                                                }
                                            >
                                                {t('ai_tracking.prompt_generator.generate_prompts')}
                                            </button>
                                            <div className="prompt-generation-count">
                                                {this.props.getCreditsLoader ? (
                                                    <Loading />
                                                ) : (
                                                    <>
                                                        {this.props.promptCredits}{' '}
                                                        {t(
                                                            'ai_tracking.global.prompts_generation_left',
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {!this.props.getCreditsLoader &&
                                        this.props.promptCredits === 0 && (
                                            <ErrorMessage
                                                message={t(
                                                    'ai_tracking.global.prompts_generation_left_message',
                                                )}
                                            />
                                        )}
                                </>
                            )}

                            {!this.state.isInProgressTopics && (
                                <>
                                    {firstTreeGeneratedTopics?.length > 0 &&
                                        !this.state.alreadyGeneratedTopicsLoading && (
                                            <div className="prompt-generator-subtitle already-generated-topics-header mt-10">
                                                {t(
                                                    'ai_tracking.prompt_generator.select_topics_subheader',
                                                )}{' '}
                                                <button onClick={this.props.moveToExistingPrompts}>
                                                    {t(
                                                        'ai_tracking.prompt_generator.select_topics_subheader_link',
                                                    )}
                                                </button>
                                            </div>
                                        )}
                                    {this.state.alreadyGeneratedTopicsLoading && (
                                        <div className="mt-20 d-flex gap-8">
                                            <Loading />{' '}
                                        </div>
                                    )}
                                    {firstTreeGeneratedTopics?.length > 0 && (
                                        <>
                                            <div className="already-generated-topics mt-4">
                                                {firstTreeGeneratedTopics?.map((item, index) => (
                                                    <div
                                                        key={item}
                                                        className="already-generated-topic"
                                                    >
                                                        {item}{' '}
                                                        {index <
                                                            firstTreeGeneratedTopics.length - 1 &&
                                                            ', '}
                                                    </div>
                                                ))}
                                                {alreadyGeneratedTopics?.length > 3 && (
                                                    <button
                                                        onClick={this.props.moveToExistingPrompts}
                                                    >
                                                        See All
                                                    </button>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                )}
                {((this.state.topicsSource === 'ai' && this.state.showStep3ForAi) ||
                    (this.state.topicsSource === 'manual' && this.state.showStep3ForManual)) && (
                    <div className="card">
                        <div className="card-body">
                            <div className="prompt-generator-title">
                                <div className="prompt-generator-number">
                                    {this.state.topicsSource === 'manual' ? 2 : 3}
                                </div>
                                <div className="prompt-generator-label">
                                    {' '}
                                    {t('ai_tracking.prompt_generator.select_prompts')}
                                </div>
                            </div>
                            <div>
                                {this.state.loading && (
                                    <div className="mt-20 d-flex gap-8">
                                        <strong>
                                            {t('ai_tracking.prompt_generator.generate_message')}
                                        </strong>{' '}
                                        <Loading />{' '}
                                    </div>
                                )}
                                {this.state.errorMessage && (
                                    <div className="mt-20 error-message">
                                        <strong>{this.state.errorMessage}</strong>{' '}
                                    </div>
                                )}
                            </div>
                            {!this.state?.[topicKeyName]?.length &&
                                !this.state.loading &&
                                !this.state.errorMessage && (
                                    <div className="prompt-generator-subtitle">
                                        {t('global.no_data')}
                                    </div>
                                )}

                            {this.state?.[topicKeyName]?.length > 0 && (
                                <>
                                    <div className="prompt-generator-body-box">
                                        <div className="prompt-generator-body-box-content">
                                            {this.state?.[topicKeyName]
                                                .filter((_, i) => i % 2 === 0)
                                                ?.map((item, i) => (
                                                    <PromptsView
                                                        item={item}
                                                        showOpened={this.showOpened}
                                                        onClickOnStep={this.onClickOnStep}
                                                        headerKey={'name'}
                                                        promptKey="generated_prompts"
                                                        selectedItems={this.state.selectedItems}
                                                        onSelectPrompts={this.onSelectPrompts}
                                                        uniqueKey={`l-${i}`}
                                                        key={i}
                                                        onSelectAllPrompts={this.onSelectAllPrompts}
                                                    />
                                                ))}
                                        </div>
                                        <div className="prompt-generator-body-box-content">
                                            {this.state?.[topicKeyName]
                                                .filter((_, i) => i % 2 === 1)
                                                ?.map((item, i) => (
                                                    <PromptsView
                                                        item={item}
                                                        showOpened={this.showOpened}
                                                        onClickOnStep={this.onClickOnStep}
                                                        headerKey={'name'}
                                                        promptKey="generated_prompts"
                                                        selectedItems={this.state.selectedItems}
                                                        onSelectPrompts={this.onSelectPrompts}
                                                        uniqueKey={`r-${i}`}
                                                        key={i}
                                                        onSelectAllPrompts={this.onSelectAllPrompts}
                                                    />
                                                ))}
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-end mt-3 mb-5">
                                        <div>
                                            <button
                                                className="button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center gap-8"
                                                onClick={this.openAddKeywordModal}
                                                disabled={
                                                    this.state.selectedItems.length === 0 ||
                                                    this.props.available_credits === 0
                                                }
                                            >
                                                {t(
                                                    'ai_tracking.prompt_generator.track_selected_prompts',
                                                )}
                                                <div className="selected-items-count-for-track">
                                                    {this.state.selectedItems.length}
                                                </div>
                                            </button>
                                            <div className="prompt-generation-count">
                                                {this.props.balanceLoader ? (
                                                    <Loading />
                                                ) : (
                                                    <>
                                                        {this.props.available_credits}{' '}
                                                        {t(
                                                            'ai_tracking.global.prompts_tracking_left',
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {!this.props.balanceLoader &&
                                        this.props.available_credits === 0 && (
                                            <ErrorMessage
                                                message={t(
                                                    'ai_tracking.global.prompts_tracking_left_message',
                                                )}
                                            />
                                        )}
                                </>
                            )}
                        </div>
                    </div>
                )}

                {selectedProject && this.state.isEditModalOpen && (
                    <ProjectEditModal
                        isOpen={this.state.isEditModalOpen}
                        onClose={this.onCloseEditModal}
                        item={selectedProject}
                        updateData={this.props.getProjectsData}
                    />
                )}
                {this.state.isAddKeywordModalOpen && (
                    <AddKeywordModal
                        isOpen={this.state.isAddKeywordModalOpen}
                        onClose={this.closeAddKeywordModal}
                        prompts={this.state.selectedItems}
                        projectId={this.state.selectedProject}
                    />
                )}
            </>
        );
    }
}

export default withTranslation()(BrandEntities);
